import { ModelBase, QueryColumn } from '@barthauer/abc/core/data';
import { ParameterValue } from '@barthauer/abc/queries/parameters/core';

export class QueryModelBase extends ModelBase {
  PackageId: string;

  constructor() {
    super();
  }
}

export class QueryMapModelBase extends QueryModelBase {
  MapNames: string[];

  constructor() {
    super();
  }
}

export class QueryMapInfoModel extends QueryMapModelBase {
  AppIdentifier: string;
  AdditionalObjectTypeNames: string[];
  constructor() {
    super();
  }
}

export class QueryMapDataModelBase extends QueryMapModelBase {
  Parameters: ParameterValue[];

  constructor() {
    super();
  }
}

export class QueryMapObjectsDataModel extends QueryMapDataModelBase {
  ObjectSpaceName: string;
  ObjectTypeName: string;
  ObjectSetName: string;
  DataSourceId: string;
  constructor() {
    super();
  }
}

export class QueryMapObjectsModel extends QueryMapObjectsDataModel {
  AdditionalColumns?: QueryColumn[];
  AdditionalOPath?: string;
  constructor() {
    super();
  }
}

export class QueryMapObjectValuesModel extends QueryMapObjectsDataModel {
  Query: string;
  LimitCount?: number;
  constructor() {
    super();
  }
}

export class QueryMapModel extends QueryMapDataModelBase {
  DefaultProjectionName: string;
  DefaultProjectionDefinition: string;
  DefaultInitialViewbox: number[];

  constructor() {
    super();
  }
}
